import { elIds, uiClasses } from './ui-constants';

export default function injectSelectPaymentOptionCss(): void {
  if (document.getElementById(elIds.stylesheet_id) !== null) {
    return;
  }
  const spinnerStyleEl = document.createElement('style');
  spinnerStyleEl.id = elIds.stylesheet_id;
  const buttonPadding = 14;
  const cssText = document.createTextNode(`
    #${elIds.container_id} {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
    }

    .${uiClasses.radioLabel} {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-basis: 100%;
      cursor: pointer;
      padding: ${buttonPadding}px;
    }

    .${uiClasses.radioLabel} img {
      max-width: 60px;
      max-height: 32px;
    }

    .${uiClasses.radioContainer} {
      display: flex;
      position: relative;
      flex-basis: 100%;
      border: solid 1px #dddddd;
      border-radius: 4px;
      align-items: center;
    }

    .${uiClasses.optionButton} {
      display: flex;
      flex: calc(50% - ${buttonPadding * 2}px) 0 0;
      padding: ${buttonPadding}px;
    }

    @media (max-width: 480px) {
      .${uiClasses.optionButton} {
        flex-basis: calc(100% - ${buttonPadding * 2}px);
      }
    }
  `);
  spinnerStyleEl.appendChild(cssText);
  document.head.appendChild(spinnerStyleEl);
}
